import { render, staticRenderFns } from "./VesselBaseStation.vue?vue&type=template&id=5aa1d1be&scoped=true"
import script from "./VesselBaseStation.vue?vue&type=script&lang=js"
export * from "./VesselBaseStation.vue?vue&type=script&lang=js"
import style0 from "./VesselBaseStation.vue?vue&type=style&index=0&id=5aa1d1be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa1d1be",
  null
  
)

export default component.exports